import { useTranslation } from "react-i18next";
import { CheckCircle2, Calendar, CalendarClock, CalendarDays, AlertTriangle, ListChecks } from "lucide-react";
import { StatCard } from "../../components/neu/StatCard";

// 6 كروت إحصائية بأسلوب HELCOO 3D Neu — KPI Tile.
const CARDS = [
  { key: "posted",   icon: CheckCircle2,  tone: "emerald" },
  { key: "future",   icon: CalendarDays,  tone: "sky" },
  { key: "upcoming", icon: CalendarClock, tone: "amber" },
  { key: "due",      icon: Calendar,      tone: "violet" },
  { key: "overdue",  icon: AlertTriangle, tone: "rose" },
  { key: "all",      icon: ListChecks,    tone: "teal" },
];

export const DuesCards = ({ summary, active, onSelect }) => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-6" data-testid="dues-cards">
      {CARDS.map((c) => (
        <button
          key={c.key}
          type="button"
          data-testid={`dues-card-${c.key}`}
          onClick={() => onSelect?.(c.key)}
          className={`text-start transition-transform duration-200 ${
            active === c.key ? "scale-[1.02]" : "hover:-translate-y-0.5"
          }`}
        >
          <StatCard
            testId={`stat-${c.key}`}
            label={t(`acct.dues.cards.${c.key}`)}
            value={summary?.[c.key] ?? 0}
            icon={c.icon}
            tone={c.tone}
          />
        </button>
      ))}
    </div>
  );
};
